import {parseNumericInput} from '../cinematic/numericInput';
export const WEIGHT_SCALE=10000;
export const MAX_WEIGHT_UNITS=1000000000000;
export const WEIGHT_METALS=['silver','gold_18k','copper'];
export function parseWeight(value){
 const parsed=parseNumericInput(value);if(!parsed.valid||!/^\d+(?:\.\d{0,4})?$/.test(parsed.value))return null;
 const [whole,fraction='']=parsed.value.split('.');const units=BigInt(whole)*BigInt(WEIGHT_SCALE)+BigInt(fraction.padEnd(4,'0'));
 return units>BigInt(0)&&units<=BigInt(MAX_WEIGHT_UNITS)?Number(units):null;
}
export const weightText=units=>{if(!Number.isSafeInteger(units)||units<0)return '';return `${Math.floor(units/WEIGHT_SCALE)}${units%WEIGHT_SCALE?'.'+String(units%WEIGHT_SCALE).padStart(4,'0').replace(/0+$/,''):''}`;};
export function validTargets(weights,metals){return Boolean(weights&&metals?.length&&Object.keys(weights).length===metals.length&&metals.every(m=>WEIGHT_METALS.includes(m)&&Number.isSafeInteger(weights[m])&&weights[m]>0&&weights[m]<=MAX_WEIGHT_UNITS));}
const ceil=(a,b)=>(a+b-BigInt(1))/b;
function priceHundredths(quote){const value=quote?.sellPriceRial;const match=/^(\d+)(?:\.(\d{1,2}))?$/.exec(String(value));if(!match)return null;const p=BigInt(match[1])*BigInt(100)+BigInt((match[2]||'').padEnd(2,'0'));return p>BigInt(0)&&p<=BigInt(Number.MAX_SAFE_INTEGER)?p:null;}
export function suggestWeights(targetToman,metals,quotes){
 if(!Number.isSafeInteger(targetToman)||targetToman<=0||targetToman>Math.floor(Number.MAX_SAFE_INTEGER/10)||!metals.length)return null;
 const weights={};let remainder=targetToman;const each=Math.floor(targetToman/metals.length);
 for(let i=0;i<metals.length;i++){
  const metal=metals[i],price=priceHundredths(quotes[metal]);if(!price)return null;
  const amount=i===metals.length-1?remainder:each;remainder-=amount;
  // Silver orders use whole grams; other goal targets use 0.0001 gram.
  const step=metal==='silver'?BigInt(WEIGHT_SCALE):BigInt(1);
  const units=ceil(BigInt(amount)*BigInt(10)*BigInt(100)*BigInt(WEIGHT_SCALE),price*step)*step;
  if(units<=BigInt(0)||units>BigInt(MAX_WEIGHT_UNITS))return null;weights[metal]=Number(units);
 }
 return weights;
}
export function valueAtQuote(units,quote){
 if(!Number.isSafeInteger(units)||units<0)return null;const price=priceHundredths(quote);if(!price)return null;
 const value=ceil(BigInt(units)*price,BigInt(WEIGHT_SCALE)*BigInt(100));return value<=BigInt(Number.MAX_SAFE_INTEGER)?Number(value):null;
}
export function summarizeWeights(weights,quotes,holdings={}){
 const entries=Object.entries(weights||{}).map(([metal,target])=>{
  const acquired=holdings[metal]?.acquired_units||0,pending=holdings[metal]?.pending_units||0;
  const valid=Number.isSafeInteger(target)&&target>0&&target<=MAX_WEIGHT_UNITS;
  const remaining=valid?Math.max(0,target-acquired):null;return {metal,target,acquired,pending,remaining,
   costRial:valueAtQuote(target,quotes[metal]),remainingRial:valueAtQuote(remaining,quotes[metal]),
   percentage:valid?Math.min(100,Math.floor(acquired*100/target)):null};});
 const sum=key=>entries.length&&entries.every(e=>e[key]!==null)&&Number.isSafeInteger(entries.reduce((n,e)=>n+e[key],0))?entries.reduce((n,e)=>n+e[key],0):null;
 return {entries,costRial:sum('costRial'),remainingRial:sum('remainingRial')};
}

export function freeGoalAssetGrams(profile,metal='silver'){
 const position=profile?.goal_assets?.[metal];
 if(position)return Number.isSafeInteger(position.free_units)?Math.max(0,position.free_units)/WEIGHT_SCALE:0;
 const total=Number(profile?.[metal==='gold_18k'?'balance_gram_gold':metal==='copper'?'balance_gram_copper':'balance_gram']||0);return Number.isFinite(total)?Math.max(0,total):0;
}
